export default __webpack_public_path__ + "static/media/emoji-detect.097eec29.svg";